/** Normalize company name to a domain slug for favicon lookups. */
export function companySlug(company: string): string {
  return company
    .toLowerCase()
    .replace(
      /\b(inc|ltd|llc|corp|limited|pvt|plc|sa|ag|gmbh|group|india|global|international|holdings|technologies|technology|solutions|services|systems|software|consulting|hr|staffing|recruitment)\b/g,
      '',
    )
    .replace(/[^a-z0-9]/g, '');
}

/** Google favicon service — reliable fallback when stored logo URL is missing. */
export function googleFaviconUrl(company: string, tld: 'com' | 'in' = 'com'): string | null {
  const slug = companySlug(company);
  if (!slug) return null;
  const domain = `${slug}.${tld}`;
  return `https://www.google.com/s2/favicons?domain=${encodeURIComponent(domain)}&sz=64`;
}

export type CompanyLogoStep = 'primary' | 'favicon_com' | 'favicon_in' | 'fallback';

export function initialLogoStep(url?: string | null): CompanyLogoStep {
  return url ? 'primary' : 'favicon_com';
}

export function advanceLogoStep(step: CompanyLogoStep): CompanyLogoStep {
  if (step === 'primary') return 'favicon_com';
  if (step === 'favicon_com') return 'favicon_in';
  return 'fallback';
}

export function logoSrcForStep(
  step: CompanyLogoStep,
  url: string | null | undefined,
  company: string,
): string | null {
  if (step === 'primary') return url ?? null;
  if (step === 'favicon_com') return googleFaviconUrl(company, 'com');
  if (step === 'favicon_in') return googleFaviconUrl(company, 'in');
  return null;
}
